<script setup>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
// import CategoriesList from "./components/CategoriesList.vue";

</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <div class="col-md-6 col-12">
            <mini-statistics-card
              title="Total Contact"
              :value="jmlcontact"
              :icon="{
                component: 'ni ni-world',
                background: 'bg-gradient-danger',
                shape: 'rounded-circle',
              }"
            />
          </div>
          <div class="col-md-6 col-12">
            <mini-statistics-card
              title="Total contact perbulan"
              :value="jmlcontactmonth"
              :icon="{
                component: 'ni ni-cart',
                background: 'bg-gradient-warning',
                shape: 'rounded-circle',
              }"
            />
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="row">
                  <div class="col-sm-5">
                    <h6 class="mb-2">Consultation Guest</h6>
                  </div>
                  <div class="col-sm-7">
                    <div class="input-group mb-3">
                      <input type="search" class="form-control form-control-sm" placeholder="Cari title disini..." id="cari" name="cari" v-model="searchQuery" aria-label="Recipient's username" aria-describedby="cari">
                      <button class="btn btn-outline-secondary btn-sm" style="margin-bottom: 0%;" type="button" id="cari" @click="cari"><i class="fas fa-search"></i></button>
                    </div>
                  </div>
                </div>
                
              </div>
              <div class="table-responsive">
                <table class="table align-items-center">
                  <thead>
                    <tr>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Name
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Contact
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Company
                      </th>
                      <th
                        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 text-center"
                      >
                        Topic
                      </th>
                      <th
                        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
                      >
                        Action
                      </th>
                      
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in paginatedData" :key="index">
                      <td>
                        <h5>{{ item.name }}</h5>
                      </td>
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">
                              Email:
                            </p>
                            <h6 class="mb-0 text-sm">{{ item.email }}</h6>
                          </div>
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">
                              WhatsApp:
                            </p>
                            <h6 class="mb-0 text-sm">{{ item.whatsapp_number }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm">{{ item.company_name }}</h6>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <h6 class="mb-0 text-sm">{{ item.topic }}</h6>
                        </div>
                      </td>
                      <td class="text-center">
                        <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)"><i class="fa fa-trash"></i></button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="d-flex justify-content-center">
                  <argon-pagination>
                    <!-- Previous Page Button -->
                    <argon-pagination-item 
                      prev  
                      :disabled="currentPage === 1" 
                      @click="prevPage"
                    />
                    
                    <!-- Page Numbers -->
                    <argon-pagination-item 
                      v-for="page in totalPages" 
                      :key="page" 
                      :label="String(page)" 
                      :active="currentPage === page" 
                      @click="setPage(page)"
                    />
                    
                    <!-- Next Page Button -->
                    <argon-pagination-item 
                      next  
                      :disabled="currentPage === totalPages" 
                      @click="nextPage"
                    />
                  </argon-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
// import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  data() {
    return {
      consulList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      totalPages: [], // Total number of pages
      itemsPerPage:10,
      sortOrder: 'desc',
      searchQuery: '',
      pages: 'solution',
      showModal: false, // Controls modal visibility
      formData: {
        pages: 'solution',
        title: '',
        cover: null,
        files: [],
        desciption: ['',''],
      },
      method: 'add',
      alertstatus: null,
      alerttext: null,
      jmldetail: 2,
      jmlcontact: 0,
      jmlcontactmonth: 0
    };
  },
  components: {
   ArgonPagination,
   ArgonPaginationItem,
   },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchconsulList();
  },
  computed: {
    totalItems() {
      return this.consulList.length;
    },
    paginatedData() {
      return this.consulList.slice(0, this.itemsPerPage);
    },
  },
  methods: {
    async fetchconsulList() {
      let access_token = localStorage.getItem('access_token');
      const config = {
        method: "get",
        url: "https://api-profile.productscala.online/admin/consultation_guest",
        params: {
          sort: this.sortOrder,
          limit: this.itemsPerPage,
          paginate: this.currentPage,
          key_search: this.searchQuery,
        },
        headers: {
          'Authorization': 'Bearer '+ access_token // Replace with the actual token
        },
      };

      await axios
        .request(config)
        .then((response) => {   
          if (response.data?.message == 'success') {
            this.consulList = response.data.data.consultaion_list; // Assign banner_list to local data
            this.jmlcontact = response.data.data.consultaion_list.length;
            this.totalPages = response.data.data.paginate; // Update the total number of pages (this depends on how the API returns pagination info)
            this.jmlcontact = response.data.data.count_all_ada;
            this.jmlcontactmonth = response.data.data.count_this_month;
          }else{
            this.alertstatus = 'danger';
            this.alerttext = 'Error get data'
          }
        })
        .catch((error) => {
          var err = error.response.data.message
          this.alertstatus = 'danger';
          this.alerttext = err
          console.error("Error fetching data:", error);
        });
    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchconsulList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchconsulList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchconsulList();
    },
    updateItemsPerPage() {
      this.fetchconsulList();
    },
    updatesoftby(){
      this.fetchconsulList();
    },
    changepages(){
      console.log(this.pages);
      this.fetchconsulList();
    },
    cari(){
      this.fetchconsulList();
    },
    async hapus(id) {
      let access_token = localStorage.getItem('access_token');
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      });

      if (result.isConfirmed) {
        const config = {
          method: 'delete', // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: 'https://api-profile.productscala.online/admin/consultation_guest/' + id,
          headers: {
            'Authorization': 'Bearer ' + access_token // Replace with the actual token
          }
        };

        try {
          const response = await axios.request(config);
          if (response.data?.message == 'success') {
            await this.fetchconsulList(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success"
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error"
            });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error"
          });
        }
      }
    },
  }
}
</script>
